import React, { useEffect, useRef, useState, useContext, createContext } from 'react';
import { Button, Form, Input, Row, Col, message, Spin, Typography } from "../ui/ot";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import HolidayDetailPicker from './holiday_detail_picker';
import { useHoliday } from './controller/use_holiday_controller';

const HolidayDetailOverView = ({
    keyPrefix = "shift_management.holiday_overview.detail",
}) => {
    const { t } = useTranslation("translation", { keyPrefix });
    const [searchParams] = useSearchParams()
    const holiday_setting_id = searchParams?.get('holiday_setting_id')
    const [loading, set_loading] = useState(0);
    const [holidayDatas, setHolidayDatas] = useState([])
    const [moreHolidayDatas, setMoreHolidayDatas] = useState([])
    const [defaultValue, setDefaultValue] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState("get")
    const get_datas = (param, sort, filter, checklist) => {
        set_loading(true);
        // getBillPaymentClassData({
        //     cur_page: param?.current,
        //     size: param?.pageSize,
        // })
    }
    const reload = () => {
        getHolidaySettingData({
            holiday_setting_id: holiday_setting_id
        }).then((response) => {
            let data = response?.data || []

        })
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "patch") {
                message.success("修改成功")
                reload()
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "patch") {
                message.error("修改失敗")
                reload()
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        setModalLoading(false)

    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const {
        HolidaySettingDatas,
        getHolidaySettingData,
        patchHolidaySettingData
    } = useHoliday({
        onBefore: onBefore,
        onFinish: onFinish
    })
    const save = () => {
        let data = [
            {
                ...defaultValue,
                holiday_setting_holiday_data: holidayDatas,
                else_holiday_data: moreHolidayDatas
            }
        ]
        patchHolidaySettingData(data)
    }
    useEffect(() => {
        getHolidaySettingData({
            holiday_setting_id: holiday_setting_id
        })
    }, [holiday_setting_id])
    useEffect(() => {
        let firstData = HolidaySettingDatas.find((ele) => true)
        let holiday_setting_holiday_data = firstData?.holiday_setting_holiday_data || []
        let else_holiday_data = firstData?.else_holiday_data || []
        setDefaultValue(firstData)
        setHolidayDatas(holiday_setting_holiday_data)
        setMoreHolidayDatas(else_holiday_data)
    }, [HolidaySettingDatas])
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Spin spinning={modalLoading}>
                    <Row gutter={[8, 16]} justify={'space-between'}>
                        <Col span={24}>
                            <Row justify={'space-between'} >
                                <Col   >
                                    <Typography.Title level={2}>
                                        {`${t('year_batch')}`}:{defaultValue?.holiday_setting_year}-01-01 ~{defaultValue?.holiday_setting_year}-12-31
                                    </Typography.Title>
                                </Col>
                                <Col  >
                                    <Row gutter={[8, 8]} align="middle">
                                        <Col>
                                            {t('total_public_holiday')}{holidayDatas.filter(tmp => tmp.isholiday === "true").length + moreHolidayDatas.length}
                                        </Col>
                                        <Col>
                                            <Button
                                                type='primary'
                                                onClick={() => save()}
                                            >
                                                {t('save')}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <HolidayDetailPicker
                                year={defaultValue?.holiday_setting_year}
                                holidayDatas={holidayDatas}
                                moreHolidayDatas={moreHolidayDatas}
                                setHolidayDatas={setHolidayDatas}
                                setMoreHolidayDatas={setMoreHolidayDatas}
                            />
                        </Col>
                    </Row>
                </Spin>
            </Col>
        </Row>
    )
}
export default HolidayDetailOverView; 
